<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changeInfoManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tài khoản bên cạnh ảnh đại diện, rồi nhấn vào icon [Thông tin cá nhân].</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeInfoManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào thanh [Thông tin cá nhân] ở bên trái màn hình, thì các thông tin sẽ được hiển thị như bên phải màn hình.</p>
                    <p>③ Nếu muốn chỉnh sửa, nhấn vào nút [Chỉnh sửa] ở góc dưới bên phải màn hình.</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeInfoManual-3.png" alt="" /></div>
                <div>
                    <p>④ Chỉnh sửa thông tin cá nhân.</p>
                    <p>⑤ Sau đó, nhấn nút [Lưu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/changeInfo_manual.vue